import NewEditEducacaoInclusivaPage from "@/Pages/EducacaoInclusiva/NewEditEducacaoInclusivaPage.vue";
import FichaDiarioAtendimento from "@/Pages/EducacaoInclusiva/FichaDiarioAtendimento.vue";
import NewEditFichaDiarioAtendimento from "@/Pages/EducacaoInclusiva/NewEditFichaDiarioAtendimento.vue";
import PlanejamentoMensalCAEE from "@/Pages/EducacaoInclusiva/PlanejamentoMensalCAEE.vue";
import PlanoCAEE from "@/Pages/EducacaoInclusiva/PlanoCAEE.vue";
import PAEE from "@/Pages/EducacaoInclusiva/PAEE.vue";
import { can } from "@/plugins/can";

export default [
  {
    path: "/educacao-inclusiva/create/:matricula_id",
    name: "educacaoInclusiva.create",
    component: NewEditEducacaoInclusivaPage,
    props: { editing: false },
  },
  {
    path: "/educacao-inclusiva/edit/:matricula_id",
    name: "educacaoInclusiva.edit",
    component: NewEditEducacaoInclusivaPage,
    props: { editing: true },
  },
  {
    path: "/educacao-inclusiva/ficha-diario-atend/:matricula_id/:gestaoDeAulasId",
    name: "educacaoInclusiva.fichaDiarioAtendimento",
    component: FichaDiarioAtendimento,
    beforeEnter(to, from, next) {
      if (!can(["educacaoInclusiva.syncAll", "educacaoInclusiva.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/educacao-inclusiva/diario-atendimento/create/:matricula_id/:gestaoDeAulasId",
    name: "educacaoInclusivaDiario.create",
    component: NewEditFichaDiarioAtendimento,
    props: { editing: false },
    beforeEnter(to, from, next) {
      if (!can(["educacaoInclusiva.syncAll", "educacaoInclusiva.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/educacao-inclusiva/:gestaoDeAulasId/diario-atendimento/:id/edit/:matricula_id",
    name: "educacaoInclusivaDiario.edit",
    component: NewEditFichaDiarioAtendimento,
    props: { editing: true },
    beforeEnter(to, from, next) {
      if (!can(["educacaoInclusiva.syncAll", "educacaoInclusiva.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/educacao-inclusiva/planejamento-mensal-caee/:matricula_id/:gestaoDeAulasId",
    name: "educacaoInclusiva.planejamentoMensalAEE",
    component: PlanejamentoMensalCAEE,
  },
  {
    path: "/educacao-inclusiva/plano-caee/:matricula_id/:gestaoDeAulasId",
    name: "educacaoInclusiva.planoCAEE",
    component: PlanoCAEE,
    beforeEnter(to, from, next) {
      if (!can(["educacaoInclusiva.syncAll", "educacaoInclusiva.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
  {
    path: "/educacao-inclusiva/paee/:matricula_id/:gestaoDeAulasId",
    name: "educacaoInclusiva.paee",
    component: PAEE,
    beforeEnter(to, from, next) {
      if (!can(["educacaoInclusiva.syncAll", "educacaoInclusiva.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
